'use strict';

/**
 * A class to keep track of velocity along a single axis.
 * Created for and used by SlickContainer.
 * 
 * TODO Do I have velocity and speed correct? Or am I using them backwards?
 * 
 * @param {number} maxTimeMeasure - The max amount of time velocity is recorded over.
 * @param {number} timePerRecord - The amount of time each entry is weighted over.
 */
function VelocityRecord(maxTimeMeasure, timePerRecord) {
	this._maxTimeMeasure = maxTimeMeasure;
	this._timePerRecord = timePerRecord;
	this._recordIndxMax = Math.round(maxTimeMeasure / timePerRecord);
	
	this.clear();
}

/**
 * @public
 */
VelocityRecord.prototype.record = function(deltaX, timeDelta) {
	var velocity = deltaX / timeDelta;
	
	// Determine direction and record direction
	var newDirection;
	if (velocity > 0) {
		newDirection = +1;
	} else if (velocity === 0) {
		newDirection = 0;
		velocity = 0; // Make sure positive zero (vs negative zero)
	} else {
		newDirection = -1;
	}
	
	if (newDirection !== 0) {
		// Record direction if it is not sitting still
		this._direction = newDirection;
		if (newDirection !== this._direction) {
			// Changed directions
			this.clear();
		}
	}
	
	// Record velocity (longer timeDelta get more entries)
	if (this._records === null) {
		this._recordIndx = 0;
		this._records = new Array();
	}
	
	var numberofEntriesForRecord = timeDelta <= this._timePerRecord ? 1 : Math.round(timeDelta / this._timePerRecord);
	while (numberofEntriesForRecord--) {
		if (this._recordIndx > this._recordIndxMax) {
			this._recordIndx = 0;
		}
		this._records[this._recordIndx] = velocity;
		this._recordIndx++;
	}
}

/**
 * @public
 */
VelocityRecord.prototype.clear = function() {
	this._records = this._direction = null;
}

/**
 * @public
 */
VelocityRecord.prototype.getDirection = function() {
	return this._direction;
}

/**
 * @public
 */
VelocityRecord.prototype.getSpeed = function() {
	var speed = 0;
	if (this._records !== null) {
		var total = 0, tally = 0;
		for ( var val, indx = 0, len = this._records.length; indx < len; indx++) {
			val = this._records[indx];
			if (val !== undefined) {
				total += val;
				tally++;
			}
		}
		speed = total/tally;
	}
	return speed;
}


module.exports = VelocityRecord;

